import React from 'react';
import NotificationView from './NotificationView';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import NotificationsRightSidebar from '../NotificationsList/NotificationsRightSidebar';

export default ColumnsContent(NotificationView, () => (
  <NotificationsRightSidebar listReduceName="eventsModule.lists.eventsUserNoticesList" />
));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Notifications/NotificationView/index.js